export { PRICING_FLAG } from './featureFlagConstant';

export const PRODUCT_TYPE = {
  API: 'API',
  CLOUD: 'Cloud',
} as const;

export const PACKAGE_SIZE = {
  CUSTOM: 'Custom',
  LARGE: 'Large',
  MEDIUM: 'Medium',
  SMALL: 'Small',
} as const;

export const BILLING_TYPE = {
  KRW_TAX_INVOICE: 'KRWTaxInvoice',
  USD_INVOICE: 'USDInvoice',
} as const;

// NOTE: 서버가 내려주는 주문 상태입니다. Expired 는 서버 상태가 아니라 표시 전용입니다
export const ORDER_STATUS = {
  CANCELED: 'Canceled',
  COMPLETED: 'Completed',
  DRAFT: 'Draft',
  PAYMENT_PENDING: 'PaymentPending',
  RECEIVED: 'Received',
} as const;

export const ORDER_DISPLAY_STATUS = {
  ...ORDER_STATUS,
  EXPIRED: 'Expired',
} as const;

export const PROCESSING_ORDER_STATUS_LIST = [
  ORDER_STATUS.DRAFT,
  ORDER_STATUS.RECEIVED,
  ORDER_STATUS.PAYMENT_PENDING,
] as const;

// NOTE: 패키지 가격·프레임·기간은 cordoba 스타터 패키지 표(GET /plan/packages)가 진실이고, 표에 없는 멤버 수만 여기서 정합니다
export const CLOUD_PACKAGE_MEMBER_COUNT = 10;

export const CLOUD_STARTER_PACKAGE_LIST = [
  PACKAGE_SIZE.SMALL,
  PACKAGE_SIZE.MEDIUM,
  PACKAGE_SIZE.LARGE,
] as const;

// NOTE: 스타터 패키지 표에서 기간별 AI Modeling 참고 금액 행을 가리키는 package 값입니다
export const AI_MODELING_PACKAGE_LIST = [
  'AIModeling6M',
  'AIModeling12M',
] as const;

export const PRICING_ROUTE_PATH = '/pricing';
